<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" :rules="rules" ref="form" label-width="130px"
        v-loading="loading">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="ygId" label="仓库名称">
              <el-select v-model="formData.ygId" clearable placeholder="请选择仓库名称">
                <el-option v-for="(item, index) of ygList" :value="item.warehouseName" :label="item.warehouseName"
                  :key="index"></el-option>
              </el-select> </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="ygDate" label="费用发生日期">
              <el-date-picker v-model="formData.ygDate" placeholder="请选择费用发生日期" type="date" clearable
                format="yyyy-MM-dd" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="userId" label="费用发生人">
              <el-select v-model="formData.userId" clearable placeholder="请选择费用发生人">
                <el-option v-for="(item, index) of userList" :value="item.userId" :label="item.userName"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="unitPrice" label="单价(元)">
              <el-input-number v-model="formData.unitPrice"></el-input-number>
            </el-form-item>
          </el-col>

        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="ygNumber" label="数量">
              <el-input-number v-model="formData.ygNumber"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="allPrice" label="总价(元)">
              <el-input-number v-model="formData.allPrice"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="costType" label="费用类型">
              <el-select v-model="formData.costType" clearable filterable placeholder="请选择费用类型">
                <el-option v-for="(item, index) of costTypeList" :value="item.value" :label="item.label"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>

              <el-button type="primary" @click="submit">提交</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>

  </div>
</template>

<script>
import { costTypeList } from '@/utils/dict'
import { mapToObjectArray } from '@/utils/utils'
export default {
  name: 'OilTankCostAdd',

  data() {
    return {
      costTypeList: mapToObjectArray(costTypeList),
      formData: {
        ygId: '',
        ygDate: '',
        userId: '',
        unitPrice: '',
        ygNumber: '',
        ygUnit: '',
        allPrice: '',
        costType: ''
      },
      rules: {
        ygId: [
          {
            required: true,
            message: '请选择油罐名称',
            trigger: ['blur', 'change']
          }
        ],
        ygDate: [
          {
            required: true,
            message: '请选择费用发生日期',
            trigger: ['blur', 'change']
          }
        ],
        userId: [
          {
            required: true,
            message: '请选择费用发生人',
            trigger: ['blur', 'change']
          }
        ],
        unitPrice: [
          {
            required: true,
            message: '请输入单价(元)',
            trigger: ['blur', 'change']
          }
        ],
        ygNumber: [
          {
            required: true,
            message: '请输入数量',
            trigger: ['blur', 'change']
          }
        ],
        ygUnit: [
          {
            required: true,
            message: '请选择数量单位',
            trigger: ['blur', 'change']
          }
        ],
        allPrice: [
          {
            required: true,
            message: '请输入总价(元)',
            trigger: ['blur', 'change']
          }
        ],
        costType: [
          {
            required: true,
            message: '请选择费用类型',
            trigger: ['blur', 'change']
          }
        ]
      },
      loading: false,
      ygList: [],
      userList: []

    }
  },
  created() {
    this.loadDict()
    if (this.id) {
      this.loadData()
    }
  },
  computed: {
    id() {
      return this.$route.query.id
    }
  },
  methods: {
    loadDict() {
      // 油罐
      // this.$axios.get(this.$apis.oiltabkManage.selectYgInfoByList).then(res => {
      //   this.ygList = res.list || []
      // })

      this.$axios.get(this.$apis.prodManage.selectLyWarehouseByPage).then(res => {
        this.ygList = res.list.map(item => {
          return {
            warehouseId: item.warehouseId,
            warehouseName: item.warehouseName
          }
        })
      })

      // 用户
      this.$axios.get(this.$apis.system.selectSysUserByPage, {
        userType: '2'
      }).then(res => {
        this.userList = res.list || []
      })
    },

    loadData() {
      this.loading = true
      this.$axios
        .get(this.$apis.oilTankCost.selectYgCostById, {
          params: { id: this.id }
        })
        .then(res => {
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    },

    submit() {
      this.$refs.form.validate().then(() => {
        this.loading = true
        let url = this.$apis.oilTankCost.insertYgCost
        if (this.id) {
          url = this.$apis.oilTankCost.updateYgCost
        }
        this.$axios.post(url, this.formData).then(() => {
          this.$router.back()
        })
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
.shoufa-form {
  width: 800px;
}

::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 100%;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}
</style>
